import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import getPhotoSizeServerFromDimensions from './getPhotoSizeServerFromDimensions';
import { X_AT_KEY } from './api';

type Args = {
  baseUrl?: string;
  id: string | number;
  size: PhotoSizeDimensions;
};

const getUserProfilePhotoUrl = ({ baseUrl, id, size }: Args) => {
  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);
  params.set('size', getPhotoSizeServerFromDimensions(size));

  return `${baseUrl || ''}/api/alltrails/v2/profile_photos/${id}/image?${params.toString()}`;
};

export default getUserProfilePhotoUrl;
